import { gql, TypedDocumentNode } from '@apollo/client';
import { AccountDesignerPreferencesVertical } from '../../useDesigners';

export type UnfollowDesignerMutation = {
  __typename: 'UnfollowDesignerPayload';
};

export type UnfollowDesignerMutationVariables = {
  userId: number;
  designerId: number;
  vertical: AccountDesignerPreferencesVertical;
};

export const UNFOLLOW_DESIGNER_MUTATION: TypedDocumentNode<
  UnfollowDesignerMutation,
  UnfollowDesignerMutationVariables
> = gql`
  mutation UnfollowDesignerMutation(
    $userId: Number!
    $designerId: Number!
    $vertical: AccountDesignerPreferencesVertical
  ) {
    unfollowDesigner(userId: $userId, designerId: $designerId, vertical: $vertical)
      @rest(
        type: "UnfollowDesignerPayload"
        endpoint: "preferences"
        method: "DELETE"
        path: "/v1/preferences?designer_id={args.designerId}&user_id={args.userId}&vertical={args.vertical}"
      ) {
      NoResponse
    }
  }
`;
